import Link from "next/link";

import PageBanner from "@/components/data-display/pageBanner";
import MetaData from "@/components/seo/MetaData";
import { RobodocInfo } from "@/utils/constants";

function PrivacyPolicy() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/privacy-policy`;

  return (
    <>
      <MetaData url={pageUrl} />

      <PageBanner
        bannerText="Our Privacy Policy"
        secondText={"Last updated: 20 January, 2023"}
      />
      <div className="container leading-7">
        <p className="mt-[2rem] font-medium">
          This privacy policy has been made for better serve those who are
          concerned with how their ‘Personally Identifiable Information’ (PII)
          is being used online. Please read our privacy policy carefully to get
          a clear understanding of how we collect, use, protect or otherwise
          handle your Personally Identifiable Information(PII) in accordance
          with our website.
        </p>
      </div>

      <div className="container mb-[5.656rem] mt-[2rem] space-y-[2.75rem]">
        <div>
          <p className="text-[1.125rem] font-bold">
            WHAT PERSONAL INFORMATION DO WE COLLECT FROM THE PEOPLE THAT VISIT
            OUR WEBSITE?
          </p>

          <p className="mt-[1.25rem]">
            When ordering or registering on our site, as appropriate, you will
            be asked to enter your name, email address, mailing address, phone
            number or other details to help you with your experience.
          </p>
        </div>
        <div>
          <p className="text-[1.15rem] font-bold">
            WHEN DO WE COLLECT INFORMATION?
          </p>

          <p className="mt-[1.25rem]">
            We collect information from you when you register on our site, place
            an order, subscribe to a newsletter or enter information on our
            site.
          </p>
        </div>
        <div>
          <p className="text-[1.15rem] font-bold">
            HOW DO WE USE YOUR INFORMATION?
          </p>

          <div className="mt-[1.25rem]">
            We may use the information we collect from you when you register,
            make a purchase, sign up for our newsletter, respond to a survey or
            marketing communication, or use certain other site features in the
            following ways: • To personalize your experience and to allow us to
            deliver the type of content and product offerings in which you are
            most interested.
            <li>
              To allow us to better service you in responding to your customer
              service requests.
            </li>
            <li>
              To administer a contest, promotion, survey or other site features.
            </li>
            <li>To quickly process your transactions.</li>
          </div>
        </div>
        <div>
          <p className="text-[1.15rem] font-bold">
            HOW DO WE PROTECT YOUR INFORMATION?
          </p>

          <p className="mt-[1.25rem]">
            We only provide articles and information. We never ask for credit
            card numbers. We use regular Malware Scanning.
            <p className="mt-[1.25rem]">
              Your personalinformation is contained behind secured networks and
              is only accessible by a limited number of persons who have special
              access rights to such systems, and are required to keep the
              information confidential. In addition, all sensitive/credit
              information you supply is encrypted via Secure Socket Layer (SSL)
              technology.
            </p>
            <p className="mt-[1.25rem]">
              We implement a variety of security measures when a user places an
              order enters, submits, or accesses their information to maintain
              the safety of your personal information.
            </p>
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">DO WE USE ‘COOKIES’?</p>
          <p className="mt-[1.25rem]">
            Yes. Cookies are small files that a site or its service provider
            transfers to your computer’s hard drive through your Web browser (if
            you allow) that enables the site’s or service provider’s systems to
            recognize your browser and capture and remember certain information.
            For instance, we use cookies to help us remember and process the
            items in your shopping cart. They are also used to help us
            understand your preferences based on previous or current site
            activity, which enables us to provide you with improved services. We
            also use cookies to help us compile aggregate data about site
            traffic and site interaction so that we can offer better site
            experiences and tools in the future.
          </p>

          <p className="mt-[2rem] font-bold">We use cookies to</p>
          <div className="space-y-[1.25rem]">
            <div className="mt-[1.25rem]">
              <li> Help remember and process the items in the shopping cart</li>
              <li> Understand and save user’s preferences for future visits</li>
            </div>
            <p>
              You can choose to have your computer warn you each time a cookie
              is being sent, or you can choose to turn off all cookies
            </p>
            <p>
              *If you turn cookies off, some features will be disabled. It won’t
              affect the user’s experience that make your site experience more
              efficient and may not function properly
            </p>
            <p>However, you will still be able to place orders. </p>
          </div>
        </div>

        <div>
          <p className="text-xl font-bold">THIRD-PARTY DISCLOSURE</p>

          <p className="mt-[1.25rem]">
            We do not sell, trade, or otherwise transfer to outside parties your
            Personally Identifiable Information.
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">THIRD-PARTY LINKS</p>

          <p className="mt-[1.25rem]">
            Occasionally, at our discretion, we may include third-party links or
            services on our website. These third-party sites have separate and
            independent privacy policies. We therefore have no responsibility or
            liability for the content and activities of these linked sites.
            Nonetheless, we seek to protect the integrity of our site and
            welcome any feedback about these sites.
          </p>
        </div>
        <div>
          <p className="text-xl font-bold">GOOGLE</p>

          <p className="word-wrap text mt-[1.25rem] break-words">
            Google’s advertising requirements can be summed up by Google’s
            Advertising Principles. They are put in place to provide a positive
            experience for users.
            <Link
              className="underline"
              href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
            >
              https://support.google.com/adwordspolicy/answer/1316548?hl=en
            </Link>
            We have not enabled Google AdSense on our site but we may do so in
            the future.
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">
            HOW DOES OUR SITE HANDLE DO NOT TRACK SIGNALS?
          </p>

          <p className="mt-[1.25rem]">
            We honor Do Not Track signals and Do Not Track, plant cookies, or
            use advertising when a Do Not Track (DNT) browser mechanism is in
            place.
          </p>
        </div>
        <div>
          <p className="text-xl font-bold">
            DOES OUR SITE ALLOW THIRD-PARTY BEHAVIORAL TRACKING?
          </p>

          <p className="mt-[1.25rem]">
            It’s also important to note that we do not allow third-party
            behavioral tracking.{" "}
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">FAIR INFORMATION PRACTICES</p>

          <p className="mt-[1.25rem]">
            The Fair Information Practices Principles form the backbone of
            privacy law in Bangladesh and the concepts they include have played
            a significant role in the development of data protection laws.
            Understanding the Fair Information Practice Principles and how they
            should be implemented is critical to comply with the various privacy
            laws that protect personal information.
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">
            In order to be in line with Fair Information Practices we will take
            the following responsive action, should a data breach occur:
          </p>

          <div className="mt-[1.25rem]">
            <li>
              Within 1 business day, we will notify the users via in-site
              notification{" "}
            </li>
            <li>Within 1 business day </li>
          </div>
        </div>

        <div>
          <p className="text-xl font-bold">CAN SPAM ACT</p>

          <p className="mt-[1.25rem]">
            The CAN-SPAM Act is a law that sets the rules for commercial email,
            establishes requirements for commercial messages, gives recipients
            the right to have emails stopped from being sent to them, and spells
            out tough penalties for violations.
          </p>
        </div>

        <div>
          <p className="text-xl font-bold">
            WE COLLECT YOUR EMAIL ADDRESS IN ORDER TO:
          </p>

          <div className="mt-[1.25rem]">
            <li>
              Send information, respond to inquiries, and/or other requests or
              questions.
            </li>
            <li>
              Process orders and to send information and updates pertaining to
              orders.
            </li>
            <li>
              Send you additional information related to your product and/or
              service.
            </li>
          </div>
        </div>

        <div>
          <p className="text-xl font-bold">
            TO BE IN ACCORDANCE WITH CANSPAM, WE AGREE TO THE FOLLOWING:
          </p>

          <div className="mt-[1.25rem]">
            <li>Not use false or misleading subjects or email addresses.</li>
            <li>Honor opt-out/unsubscribe requests quickly.</li>
          </div>
        </div>

        <div>
          <p className="text-xl font-bold">
            If at any time, you would like to unsubscribe from receiving future
            emails, you can email us at
          </p>

          <div className="mt-[1.25rem]">
            <Link
              href={`mailto:${RobodocInfo.email1}`}
              className="text-[#004DCC] underline"
            >
              {RobodocInfo.email1}
            </Link>
            <br /> and we will promptly remove you from ALL correspondence.
          </div>
        </div>

        <div>
          <p className="text-xl font-bold">CONTACTING US</p>

          <p className="mt-[1.25rem]">
            If there are any questions regarding this privacy policy, you may
            contact us using the information below.
          </p>

          <div className="mt-[1.25rem] text-[#004DCC] underline">
            <a href={RobodocInfo.website}>robodocbd.com</a>
            <br />
            <Link href={`mailto:${RobodocInfo.email1}`} className="underline">
              {RobodocInfo.email1}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
